import '../../assets/styles/Footer.css'
import {
    FaInstagram
} from "react-icons/fa";
import Container from 'react-bootstrap/Container';
import {Stack} from "react-bootstrap";
import {ReactComponent as Monstera} from "../../assets/images/monstera-leaf.svg";
import {Link} from "react-router-dom";

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const studioAddress = "950 Pacific Ave Suite 812, Tacoma, WA 98402";
    const mapLink = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2708.1079985961824!2d-122.44153252261515!3d47.25359141228653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x848dc019ed23be37%3A0xefd5c3ae09e8028b!2sCygni%20Tattoo!5e0!3m2!1sen!2sus!4v1761881173153!5m2!1sen!2sus";

    return (
        <Container fluid className='d-flex flex-column footer-container pt-3'>
            <Container className="d-flex flex-column mx-auto">
                {/* Footer social links */}
                <Stack className="mx-auto mb-3" direction="horizontal" gap={3}>
                    <a href="https://www.instagram.com/erika.tattoo.art/">
                        <FaInstagram size={40}/>
                    </a>
                </Stack>
                <Container as="address" className='bg-light d-flex flex-column text-center p-2 mb-3 rounded-3'>
                    <p>
                        Cygni Tattoo <br/>
                        {studioAddress}
                    </p>
                    <iframe
                        title="findUs"
                        referrerPolicy="no-referrer-when-downgrade"
                        src={mapLink}
                        allowFullScreen
                        loading="lazy"
                        className="mb-3"
                    ></iframe>
                </Container>
                <Container className={"d-flex column-gap-3 justify-content-center align-items-center p-2"}>
                    <Monstera style={{height: "40px", width: "40px"}}/>
                    <span className='small text-center'>&copy; Copyright {currentYear},
                        Botanical Ink LLC
                    </span>
                    <Link to={"/admin"}>
                        <Monstera style={{height: "40px", width: "40px"}}/>
                    </Link>
                </Container>
            </Container>
        </Container>
    );
};

export default Footer;